import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppService } from '../../core/service/app.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { TrackingSignalrService } from '../../core/service/tracking-signalr.service';
import { OrderAlertService } from '../../core/service/order-alert.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [NgbModule, TooltipModule, CommonModule, BadgeModule, RouterLink],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent implements OnInit, OnDestroy {
  isCollapsed = true;
  unreadOrderCount = 0;
  isStoreAdmin = false;

  private readonly subs = new Subscription();

  constructor(
    private readonly appService: AppService,
    private readonly trackingService: TrackingSignalrService,
    private readonly orderAlert: OrderAlertService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.isStoreAdmin = !!this.appService.returnStoreId();

    if (this.isStoreAdmin) {
      this.orderAlert.requestPermission();
      ['click', 'keydown', 'touchstart'].forEach(evt =>
        document.addEventListener(evt, () => this.orderAlert.unlockAudio(), { once: true })
      );

      this.subs.add(
        this.trackingService.newFoodOrder$.subscribe((order: any) => {
          this.unreadOrderCount++;
          this.orderAlert.playAlertSound();

          if (document.hidden) {
            this.orderAlert.notify(
              'Nuevo pedido',
              `Pedido #${order.orderId} de ${order.customerName}`,
              () => this.router.navigate(['/admin/food-orders'])
            );
          }
        })
      );

      this.subs.add(
        this.router.events.pipe(
          filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
          if ((event.urlAfterRedirects as string).includes('/admin/food-orders')) {
            this.unreadOrderCount = 0;
          }
        })
      );
    }
  }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }
  logout() {
    this.appService.eliminarSesion();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
